import classNames from "classnames";
import { viaChannelLabel } from "@common/constants/actor";
import { Tag } from "@design-system/Tag/Tag";
import styles from "./ActorName.module.scss";

interface ActorNameProps {
    name: string;
    channelLabel?: string;
    className?: string;
}

/** The actor's name, then its channel as a tag; the hover title and accessible text read "Name via Channel". */
export const ActorName = ({
    name,
    channelLabel,
    className,
}: Readonly<ActorNameProps>) => {
    if (channelLabel === undefined) {
        return (
            <span className={className} title={name}>
                {name}
            </span>
        );
    }

    const label = viaChannelLabel(name, channelLabel);
    return (
        <span className={classNames(styles.root, className)} title={label}>
            <span className={styles.name} aria-hidden="true">
                {name}
            </span>
            <span className={styles.channel} aria-hidden="true">
                <Tag size="sm" color="neutral" outline>
                    {channelLabel}
                </Tag>
            </span>
            <span className={styles.visuallyHidden}>{label}</span>
        </span>
    );
};
